import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import api from "./services/api";
import TripsList from "./Components/TripsList";
import ProtectedRoute from "./Components/RegistrationForm/ProtectedRoute";
import Loading from "./Components/Loading";
import TripAndVariantDetails from "./Components/TripAndVariantDetails";
import "./App.css";
import { Navigate } from "react-router-dom";
import RegistrationForm from "./Components/RegistrationForm/RegistrationForm";
import ScrollToTop from "./Components/ScrollToTop";
import CustomRedirect from "./Components/CustomRedirect";
import TopBanner from "./TopBanner";
import WaitingListStatus from "./Components/WaitingListStatus";

const App = () => {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrips = async () => {
      try {
        const response = await api.getTrips();
        setTrips(response);
      } catch (err) {
        setError("Nie udało się pobrać danych o wycieczkach :( .");
      } finally {
        setLoading(false);
      }
    };

    fetchTrips();
  }, []);

  if (loading) return <Loading />;
  if (error) return <div>{error}</div>;

  return (
    <Router>
      <ScrollToTop/>
      <TopBanner/>
      <div className="app">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <TripsList title="Nadchodzące:" trips={trips.upcoming || []} footerName="SZCZEGÓŁY" isClickable={true}/>
                <TripsList title="Planowane:" trips={trips.planned || []} isClickable={false} footerName="SZCZEGÓŁY WKRÓTCE"/>
                <TripsList title="Zakończone:" trips={trips.finished || []} footerName="SZCZEGÓŁY" isClickable={true}/>
              </>
            }
          />
           <Route
            path="/r/:keyGuid"
            element={<CustomRedirect />}
          />
          <Route
            path="/:tripGuid"
            element={<TripAndVariantDetails showVariantDetails={false} />}
          />
          <Route
            path="/:tripGuid/:variantGuid"
            element={<TripAndVariantDetails showVariantDetails={true} />}
          />
          <Route
            path="register/:code"
            element={
              <ProtectedRoute
                redirectPath="/"
              >
                <RegistrationForm />
              </ProtectedRoute>
            }
          />
          <Route path="/registration-status/:reservationGuid" element={<WaitingListStatus />} />
          <Route path="*" element={<Navigate to="/" replace />} />
       </Routes>

      </div>
      </Router>
  );
};

export default App;
